// components/Layout.tsx
"use client";

import React from "react";
import Link from "next/link";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return <main className="grow">{children}</main>;
}

/* --------------------  RELATED POSTS  -------------------- */
export function RelatedPosts({
  posts = [],
}: {
  posts: { slug: string; title: string }[];
}) {
  if (!posts.length) return null;

  return (
    <aside className="card mt-5 shadow-sm">
      <div className="card-body">
        <h6 className="card-title mb-3">Related Posts:</h6>
        <ul className="mb-0">
          {posts.map((p) => (
            <li key={p.slug} className="mb-2 text-success">
              <Link href={`/blog/${p.slug}`} className="text-decoration-none">
                {p.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
